import { gql } from "@apollo/client";

export const countProfilesBySegments = gql`
  mutation CountProfilesBySegments($filter: ProfileSegmentFilter!) {
    countProfilesBySegments(filter: $filter) {
      totalUniqueUsers
      totalUniqueActiveUsers
      segmentCounts {
        segment
        userCount
      }
    }
  }
`;
